import { prop } from 'ramda'
import { useIsOwner, useSessionPermission } from '@btime/react-session'

import { useNavigation } from '../../contexts/NavigationContext'
import {
  useOpenCreateTemplateRecordModal,
  useOpenEditPlaceModal,
  useOpenEditServiceOrdersModal,
  useOpenPlaceModal
} from '../../routes/modals/modalsActions'
import { usePlaceType, useTypePermission } from '../../../modules/places/_context/PlaceTypeContext'
import { useRemovePlaces } from '../../../modules/places/list/_requests/removePlaces'
import { useSendFormActions } from '../../../modules/places/sendForm/_form/SendFormHandler'

export const usePlaceDetailsAction = item => {
  const setPlace = useOpenPlaceModal()

  return {
    click: () => setPlace(item)
  }
}

export const usePlaceLogAction = item => {
  const navigate = useNavigation()
  const isOwner = useIsOwner()

  return {
    click: () => navigate(`/logs?entityPlaceIds=${item.id}`),
    link: `/logs?entityPlaceIds=${item?.id}`,
    hasPermission: isOwner
  }
}
export const usePlaceSendFormAction = item => {
  const { openSendFormModal } = useSendFormActions()
  const hasFormPermissions = useSessionPermission('listForm')

  return {
    click: () => openSendFormModal([item.id]),
    tourStep: 'sendForm',
    hasPermission: hasFormPermissions
  }
}

export const usePlaceEditAction = item => {
  const type = usePlaceType()
  const openEditPlaceModal = useOpenEditPlaceModal()
  const canEdit = useTypePermission('edit')

  return {
    click: () => openEditPlaceModal({ id: item.id, initialState: { type } }),
    hasPermission: canEdit
  }
}

export const usePlaceTemplateRecordAction = item => {
  const canCreateTemplateRecord = useSessionPermission('createTemplateRecord')
  const openCreateTemplateRecordModal = useOpenCreateTemplateRecordModal()
  const placeType = usePlaceType()

  return {
    click: () => openCreateTemplateRecordModal({ entity: placeType, recordId: item.id }),
    hasPermission: canCreateTemplateRecord
  }
}

export const usePlaceRemoveAction = item => {
  const canDelete = useTypePermission('delete')
  const [removePlaces, { loading }] = useRemovePlaces()

  return {
    click: () => removePlaces(item?.id),
    hasPermission: canDelete
  }
}

export const usePlaceNewServiceOrderAction = ids => {
  const openEditServiceOrdersModal = useOpenEditServiceOrdersModal()
  const canCreateSO = useSessionPermission('createServiceOrder')
  const placeType = usePlaceType()

  return {
    hasPermission: canCreateSO && ids?.length <= 30,
    click: () => {
      return openEditServiceOrdersModal({ placeIds: ids, placeType })
    }
  }
}

export const usePlaceSendFormsAction = ids => {
  const { openSendFormModal } = useSendFormActions()
  const hasFormPermissions = useSessionPermission('lsitForm')

  return {
    hasPermission: hasFormPermissions,
    click: () => openSendFormModal(ids)
  }
}

export const usePlaceLogsAction = ids => {
  const navigate = useNavigation()
  const isOwner = useIsOwner()

  return {
    click: () => navigate(`/logs?entityPlaceIds=${ids?.join(',')}`),
    link: `/logs?entityPlaceIds=${ids?.join(',')}`,
    hasPermission: isOwner
  }
}

export const usePlacesRemoveAction = ids => {
  const canDelete = useTypePermission('delete')
  const [removePlaces, { loading }] = useRemovePlaces()

  return {
    click: () => removePlaces(ids),
    hasPermission: canDelete
  }
}
